import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {CropperComponent} from './cropper.component';
import {CropperService} from './cropper.service';
import {DirectivesModule} from '../../../directives/directives.module';
import {Trip2ThemeModule} from '../../../trip2-theme/trip2-theme.module';

@NgModule({
  imports: [
    CommonModule,
    DirectivesModule,
    Trip2ThemeModule
  ],
  exports: [
    CropperComponent
  ],
  declarations: [CropperComponent],
  providers: [
    CropperService
  ]
})
export class CropperModule { }



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/cropper/cropper.module.ts